export const LOGOUTMESSAGE = "There is another potential session started from same User id hence logging out for security reasons.";
export const CURRENT_BUILD_VERSION = "1.0"